import { MultiSelect } from "primereact/multiselect";

interface IMultiSelectProps {
  id?: string;
  testId?: string;
  value: any[];
  onChange: (event: any) => void;
  options: any[];
  optionLabel: string;
  placeholder?: string;
  maxSelectedLabels?: number;
  className?: string;
}

const REIMultiSelect: React.FC<IMultiSelectProps> = ({
  id,
  testId,
  value,
  onChange,
  options,
  optionLabel,
  placeholder = "Select Keywords",
  maxSelectedLabels = 3,
  className,
}) => {
  return (
    <MultiSelect
      inputId={id}
      data-testid={testId ?? id}
      value={value}
      onChange={onChange}
      options={options}
      optionLabel={optionLabel}
      placeholder={placeholder}
      maxSelectedLabels={maxSelectedLabels}
      className={className}
      selectAllLabel="All"
    />
  );
};

export default REIMultiSelect;
